// src/hooks/useSessions.ts
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import api from 'src/services/api';

export type SessionId = string | number;

// Backend’in döndürdüğü session nesnesi bilinmiyorsa minimum alanlar:
export interface ISession {
  Id: number | string;
  AccountId?: number | string;
  IpAddress?: string;
  MacAddress?: string | null;
  UserAgent?: string;
  Device?: string;             // ör: "Windows 4GB"
  Platform?: string;           // ör: "Windows"
  Country?: string;
  City?: string;
  Latitude?: number;
  Longitude?: number;
  ClientId?: string;
  CreatedAt?: string;          // ISO
  UpdatedAt?: string;          // ISO
  Language?: string;
  Timezone?: string;
  Connection?: string;
  Screen?: string;             // ör: "1920x1080"
  LastActivityAt?: string | null;
};

type UseSessionsOpts = {
  /** mount olduğunda otomatik getir (default: true) */
  autoLoad?: boolean;
  /** ms cinsinden polling; örn. 30000 (30 sn). Vermezsen kapalıdır. */
  pollMs?: number;
};

type UseSessionsReturn<T extends ISession = ISession> = {

  sessions: T[];
  loading: boolean;
  error: string | null;
  setSessions: React.Dispatch<React.SetStateAction<T[]>>;
  /** accountId parametresi vermediysen burada geçebilirsin */
  fetchSessions: (page: number, limit: number) => Promise<void>;
  /** son accountId ile tekrar yükler */
};

function extractSessions(payload: any): any[] {
  // AxiosResponse <— payload.data?.sessions | payload.sessions | payload.data | payload
  const pick =
    payload?.data?.sessions ??
    payload?.sessions ??
    payload?.data ??
    payload;
  return Array.isArray(pick) ? pick : [];
}

export default function useSessions<T extends ISession = ISession>(
  opts: UseSessionsOpts = {}
): UseSessionsReturn<T> {
  const { autoLoad = true, pollMs } = opts;

  const [sessions, setSessions] = useState<T[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Aynı anda birden fazla isteğin yarışmaması için
  const fetchSessions = async (page: number, limit: number) => {

    setLoading(true);
    setError(null);

    const controller = new AbortController();

    try {
      const res = await api.get(`/account-sessions`, {
        params: { page, limit },
      });
      console.log(res.data)
      const list = extractSessions(res) as T[];
      setSessions(list);
    } catch (err: any) {
      if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;

      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to fetch sessions';
      setError(msg);
      setSessions([]);
    } finally {
      setLoading(false);
    }

  }


  return {
    sessions,
    loading,
    error,
    fetchSessions,
    setSessions
  };
}
